import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import { FieldDropdown } from 'shared/ui'
import { IntegrationDropdownContext } from 'widgets/IntegrationDropdown/context/integrationDropdownContext'
import { type IntegrationDropdownStore } from 'widgets/IntegrationDropdown/store/integrationDropdownStore'
import { PhoneFieldTrigger } from 'widgets/IntegrationDropdown/ui/PhoneField/PhoneFieldTrigger'
import { PhoneFieldContent } from 'widgets/IntegrationDropdown/ui/PhoneField/PhoneFieldContent'
import { IntegrationTrigger } from './IntegrationTrigger'
import { IntegrationContent } from './IntegrationContent'
import styles from './styles.module.scss'

type IIntegrationDropdownProps = {
  store: IntegrationDropdownStore
}

export const IntegrationDropdown: FC<IIntegrationDropdownProps> = observer(({ store }) => {
  const { integrationError, phoneFieldError, clearIntegrationError, clearPhoneFieldError } = store
  useEffect(() => {
    return () => {
      store.reset()
    }
  }, [])

  return (
    <IntegrationDropdownContext.Provider value={store}>
      <FieldDropdown
        offset={{ x: -4 }}
        labelText={'Integration'}
        error={integrationError}
        onToggle={clearIntegrationError}
        triggerComponent={<IntegrationTrigger />}
        customComponent={(onCloseMenu, dropdownId) => (
          <IntegrationContent dropdownId={dropdownId} onCloseMenu={onCloseMenu} />
        )}
      />
      {store.selectedIntegrationItem.id !== 'custom' && (
        <div className={styles.phoneFieldContainer}>
          <FieldDropdown
            offset={{ x: -4 }}
            labelText={'Phone field'}
            error={phoneFieldError}
            onToggle={clearPhoneFieldError}
            triggerComponent={<PhoneFieldTrigger />}
            customComponent={(onCloseMenu, dropdownId) => (
              <PhoneFieldContent dropdownId={dropdownId} onCloseMenu={onCloseMenu} />
            )}
          />
        </div>
      )}
    </IntegrationDropdownContext.Provider>
  )
})
